package com.milta.core.localization.translations.it

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "IA",
    menuAiLegend = "IA: lettura automatica tramite intelligenza artificiale, che usa il tuo credito IA. Per Excel, solo se le colonne non vengono riconosciute.",
    menuExhaustedTitle = "Credito IA esaurito — azzeramento il {date}.",
    menuExhaustedMessage = "La scansione e l'importazione PDF sono disattivate. Un foglio di calcolo con le colonne previste e l'inserimento manuale restano disponibili.",
    modeDisabledReason = "Credito IA esaurito",
    exhaustedBannerWebTitle = "Credito IA esaurito — azzeramento il {date}.",
    exhaustedBannerWebMessage = "I PDF non possono più essere analizzati. Importa un file Excel o CSV con le colonne previste, oppure aggiungi le consegne a mano dall'app mobile.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) o CSV · max 500 fermate · 10 MB",
    pdfUnavailableUntil = "PDF non disponibile fino al {date}",
    pdfRefusedTitle = "Credito IA esaurito — questo PDF non può essere analizzato",
    pdfRefusedMessage = "«{file}» richiede una lettura da parte dell'IA. Il tuo credito torna il {date}. Nel frattempo, importa un file Excel o CSV con le colonne previste, oppure aggiungi le consegne a mano dall'app mobile.",
    spreadsheetExhaustedTitle = "Colonne non riconosciute — credito IA esaurito",
    spreadsheetExhaustedWebMessage = "Le colonne di «{file}» non corrispondono alle colonne previste e il tuo credito IA non permette più di riconoscerle automaticamente (ritorno il {date}). Rinomina le colonne come indicato sotto, oppure aggiungi le consegne a mano dall'app mobile.",
    expectedColumnsNoCreditHint = "Un file che rispetta queste colonne viene importato senza IA e non consuma credito, anche allo 0%.",
    importExhaustedTitle = "Credito IA esaurito",
    importExhaustedPhotoMessage = "Il tuo credito IA è arrivato allo 0% mentre questa importazione era in attesa. La foto non è stata analizzata e non è stato conteggiato nulla. Azzeramento il {date}.",
    importExhaustedFileMessage = "Il tuo credito IA è arrivato allo 0% mentre questa importazione era in attesa. Il file non è stato analizzato e non è stato conteggiato nulla. Azzeramento il {date}.",
    importSpreadsheetExhaustedMessage = "Le colonne di questo file non corrispondono alle colonne previste e il tuo credito IA non permette più di riconoscerle automaticamente. Azzeramento il {date}.",
    stepPhotoSent = "Foto inviata",
    stepFileSent = "File inviato: {file}",
    stepAnalysisNotStarted = "Analisi non avviata: credito IA esaurito",
    stepFileRead = "File letto: {file}",
    stepExpectedColumns = "Colonne previste: Nome del destinatario, Indirizzo completo",
    stepDeliveriesKept = "Le consegne già inserite sono conservate",
    retryAvailableOn = "Riprova — disponibile il {date}",
    manualEntryAction = "Inserimento manuale",
    myUsageTitle = "Il mio utilizzo",
    myUsageAttachedDriverNote = "Qui compaiono solo le tue azioni. Ciò che le tue aziende avviano per te viene conteggiato da loro.",
    tabOptimizations = "Ottimizzazioni",
    tabAiCredit = "Credito IA",
    remainingForPeriod = "Credito IA rimanente nel periodo",
    percentValue = "{percent}%",
    remainingSuffix = "di credito IA rimanente",
    lowPill = "Credito basso",
    exhaustedPill = "Esaurito · scansione e importazione PDF disattivate",
    driverNote = "Il tuo credito torna al rinnovo dell'abbonamento (quello della tua Azienda, se ne fai parte). Il credito non utilizzato non viene riportato.",
    enterpriseNote = "Torna al rinnovo del tuo abbonamento, senza riporto. Questo credito riguarda solo le tue azioni IA; ogni autista ha il suo.",
    exhaustedNote = "L'inserimento manuale e i fogli di calcolo con le colonne previste restano disponibili. Il credito torna al rinnovo del tuo abbonamento.",
    webScopeHint = "Questo credito riguarda solo le azioni IA di questo account: scansioni, importazioni PDF o foto, colonne di foglio di calcolo non riconosciute. Ogni autista ha il suo.",
    profileValue = "{optimizations} · IA {percent}%",
    profileValueAiOnly = "IA {percent}%",
    columnShare = "Quota del credito",
    actionScanDeliveryList = "Scansione elenco",
    actionScanPackageLabel = "Scansione etichetta",
    actionImportPdf = "Importazione PDF",
    actionImportUnstructured = "Importazione in background",
    actionSpreadsheetMapping = "Colonne del foglio (IA)",
    outcomeSuccess = "Riuscito",
    outcomeFailed = "Non riuscito",
    outcomeUnreadable = "Illeggibile",
    countedSuffix = "(conteggiato)",
    rowDateTime = "{date} alle {time}",
    limitsEyebrow = "Credito IA per periodo",
    limitsDescription = "Importo in euro che ogni account può consumare in chiamate IA (scansioni, importazioni PDF o foto, colonne di foglio di calcolo non riconosciute) per periodo di abbonamento. Il credito torna al limite al rinnovo dell'abbonamento, senza riporto.",
    weightedEquivalent = "≈ {tokens} token ponderati",
    limitsFootnote = "Un autista di un'Azienda riceve il limite «Autista», di prova finché la sua Azienda è in prova. L'equivalente in token è indicativo e viene ricalcolato con il tasso qui sotto.",
    conversionEyebrow = "Conversione e avviso",
    rateLabel = "Tasso di cambio",
    rateHint = "Aggiornato a mano · si applica alle chiamate successive",
    thresholdLabel = "Avviso credito basso",
    thresholdUnit = "% rimanente",
    thresholdHint = "Percentuale in arancione e banner una volta per periodo",
    calculationTitle = "Come viene calcolato il costo di una chiamata.",
    calculationBody = "Claude Haiku 4.5: 1 $ per milione di token in ingresso, 5 $ per milione di token in uscita. Token ponderato = ingresso × 1 + uscita × 5, quindi 1 $ = 1.000.000 token ponderati. Costo in euro = costo in dollari ÷ tasso. Esempio: una scansione di elenco media (5.014 ingresso + 1.792 uscita) = 13.974 token ponderati = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Limiti salvati.",
    settingsSavedDetail = "Azienda: {enterpriseTrial} prova · {enterprisePaid} a pagamento. Autista: {driverTrial} prova · {driverPaid} a pagamento. Tasso {rate}. Avviso {threshold}%.",
    limitTooHigh = "Massimo 1.000 €.",
    rateTooHigh = "Massimo 10.",
    thresholdOutOfRange = "Tra 1 e 99.",
    adminCreditTitle = "Credito IA",
    adminRemainingLine = "≈ {tokens} token ponderati rimanenti · consumato {consumed}",
    adminOverrunLine = "Consumato {consumed} · superamento di {over}",
    adminLowPill = "Credito basso · sotto il {threshold}%",
    adminLowPillNoThreshold = "Credito basso",
    adminExhaustedPill = "Credito esaurito · azioni IA disattivate",
    adminAppliedAfterReplacement = "{consumed} consumati + {remaining} rimanenti (sostituzione)",
    adminGlobalLimitLabel = "Limite globale",
    adminGlobalLimitResumes = "{source} — torna in vigore all'azzeramento",
    adminResetNoCarryOver = "Riparte da {limit}: il superamento non viene riportato",
    replaceLabel = "Sostituisci il credito rimanente",
    replaceHelp = "Da 0 a 100 €, solo per il periodo in corso. All'azzeramento, l'account riparte dal limite globale.",
    replaceHelpEnterpriseDriver = "Modifica solo il credito di {name}. Quello dell'Azienda e degli altri autisti non cambia.",
    replaceInvalid = "Inserisci un importo da 0 a 100 €.",
    replacedTitle = "Credito rimanente sostituito: {from} → {to}.",
    replacedDetail = "Per il periodo in corso. Il {date}, ritorno al limite globale ({limit}).",
    adminHistoryTitle = "Cronologia del credito IA",
    adminPeriodSummary = "Periodo in corso dal {start}: {calls} chiamate · {failed} non riuscite o illeggibili (conteggiate) · {tokens} token ponderati · {consumed}",
    columnInput = "Ingresso",
    columnOutput = "Uscita",
    columnWeighted = "Ponderati",
    columnCost = "Costo",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Il tuo credito IA è esaurito. Il file non è stato analizzato e non è stato conteggiato nulla. Azzeramento il {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
